import { render, staticRenderFns } from "./kllk-menu.vue?vue&type=template&id=01655369&scoped=true"
import script from "./kllk-menu.vue?vue&type=script&lang=js"
export * from "./kllk-menu.vue?vue&type=script&lang=js"
import style0 from "./kllk-menu.vue?vue&type=style&index=0&id=01655369&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01655369",
  null
  
)

export default component.exports